export default {
  baseURL_test: window.location.protocol + "//fatxwyapi.newhope.cn",
  baseURL: window.location.protocol + "//api2.newhope.cn",
  oaUrl_test: "http://testcoa.newhopegroup.com:8085",
  oaUrl: "http://oa.newhopegroup.com:8094",
  ossLogin_test: "http://testcoa.newhopegroup.com:8085/login",
  ossLogin: "http://oa.newhopegroup.com:8094/sso/login",
};
